import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux"
import { appendData } from "store/Mode/actions"
import BaseService from "services/BaseService";
import { toast } from "react-toastify";
import ImgModal from "../ImgModal"
import UnitImgModal from "../UnitImgModal"
import { Row, Col } from 'reactstrap'
import PropertyService from "services/Admin/PropertyService";

const FabricCanvas = ({ setHeaderList, headerList }) => {
    const [modal, setModal] = useState(false)
    const [percent, setPercent] = useState(0)
    const dispatch = useDispatch()
    const modeData = useSelector(state => state.Mode)
    const [activeCanvasData, setActiveCanvasData] = useState({
        id: "",
        path: "",
        shapes: []
    })

    const [images, setImages] = useState([])
    const [lipraryImages, setLibraryImages] = useState([])
    const propertyService = new PropertyService()

    useEffect(() => {
        const id = activeCanvasData ?.constrains ?.id
        propertyService.getDropDown(null, "Left").then(res => {
           let selected = res.data.find(item => item.id === id)

           setLibraryImages(selected?.images)
        })
    }, [activeCanvasData?.constrains?.id]);

    useEffect(() => {
        // if(images?.length > 0){
            const updatedData = modeData.images.map(img => {
                if (img.id === activeCanvasData.id) {
                    return {
                        ...img,
                        images: [...images]
                    }
                } else {
                    return img
                }
            })
            dispatch(appendData({ ...modeData, images: [...updatedData] }))
        //}
    }, [images])

    useEffect(() => {
        if (modeData) {
            const activeImage = modeData.images.find(item => item.id === modeData.currentImge.id)
            setActiveCanvasData({
                id: activeImage.id,
                path: activeImage.path,
                shapes: activeImage.shapes,
                constrains: activeImage.constrains,
                comesForm: activeImage.comesForm,
            })
            if (activeImage ?.images ?.length) {
                setImages([...activeImage ?.images])
            }
        }
    }, [])

    const addImagesHandler = (e) => {
        let files = e.target.files
        const filesData = Object.values(files)
        const uploadedImgs = []
        if (filesData.length) {
            const options = {
                onUploadProgress: (progressEvent) => {
                    const { loaded, total } = progressEvent;
                    let percentValue = (loaded * 100) / total
                    setPercent((p) => percentValue > p ? percentValue : p)
                }
            }
            Promise.all(
                filesData.map(async (file) => {
                    let res = await new BaseService().postUpload(file, options);
                    const createdFiles = { ...res.data.data, shapes: [] };
                    uploadedImgs.push(createdFiles)
                }),
            ).then(() => {
                setPercent(0)
                setImages([...images, ...uploadedImgs])
            }).catch(err=>{
                setPercent(0)
            })
        }
    }

    return (
        <>
            <Row style={{ height: "320px", padding: 0, borderRadius: "20px", background: "#a6a8a2", marginLeft: 0, overflow: "hidden" }}>
                <Col md={3} className="d-flex justify-content-center p-0 " >
                    <img src={activeCanvasData ?.path} style={{
                        width: "100%",
                        height: "100%",
                        filter: "blur(10px)",
                    }} />
                    <button
                        onClick={() => {
                            const updatedList = headerList.filter(item => {
                                if (item.id !== activeCanvasData.id) {
                                    return true
                                } else {
                                    return false
                                }
                            })
                            setHeaderList([...updatedList])
                            dispatch(appendData({
                                ...modeData,
                                currentImge: activeCanvasData.comesForm,
                                // previousImg: null,
                            }
                            ))
                        }}
                        style={{ position: "absolute", top: "35%", left: "35%", width: "40px", height: "40px", background: "none", border: "none", outline: "none", }}>
                        <i className="fas fa-arrow-left fa-2x slider-icon "  ></i></button>
                </Col>
                <Col md={6} style={{ padding: "10px 0", }} >
                    {activeCanvasData.path.length ?
                        <img src={activeCanvasData.path} style={{ height: "300px", width: "100%", borderRadius: "10px" }} alt="Unit Image" />
                        : null}

                </Col>
                <Col md={3} className="d-flex justify-content-center p-0 " >
                    <img src={activeCanvasData ?.path} style={{
                        width: "100%",
                        height: "100%",
                        filter: "blur(10px)",
                    }} />

                </Col>
            </Row>
            {percent > 0 ?
            <div className="mx-1">
                <div className="progress my-2">
                    <div
                        className="progress-bar progress-bar-striped"
                        role="progressbar"
                        style={{ width: percent + '%' }}
                        aria-valuenow={`${percent}`}
                        aria-valuemin="0"
                        aria-valuemax="100"
                    >
                    </div>
                    </div>
                </div> : <div  ></div>}
            {/* <Row style={{
                background: "#f3f3f9",
                borderRadius: "10px",
                marginTop: "200px !important",
                display: "flex",
                justifyContent: "center",
                marginLeft: "-4px",
            }} className="p-3 mt-4">
                <button className="btn btn-success" onClick={()=>{}}>Upload</button> */}

                {images.length === 0 ?
                           <Col md={12} className="parent-div my-4" >
                        <div className="p-2 bg-light " style={{ borderRadius: "10px" }} >
                            <div
                                className="px-4 w-100 btn-upload  font-size-16 py-4 "
                                style={{ border: "2px #cadff7 dashed", height: "207px", background: "#F3F3F9", borderRadius: "10px" }}>
                                <div
                                    style={{ width: "50px", height: "50px", margin: "auto", background: "white", borderRadius: "25px" }}>
                                    <i className="fas fa-cloud-upload-alt text-success " style={{ padding: "16px" }}>
                                    </i>
                                </div>
                                <div className="m-auto text-center">
                                    <span className="m-auto " > Click or drag and drop to upload multiple photo</span>
                                </div>                  

                                <div
                                    className="m-auto text-left text-primary fw-bold btn-hover"
                                >
                                    <span style={{ marginLeft: "34.5%",textDecoration:"underline" }} >from computer</span>
                                </div>
                            </div>
                            <span className="or-btn-unit" onClick={(e) => {
                                e.stopPropagation()
                            }}>or</span>
                            <p className="library-btn-unit font-size-16 text-primary fw-bold"
                                onClick={() =>{
                                    if(lipraryImages?.length===0){
                                        toast.error("Unit doesn't contain images")
                                    }else{
                                        setModal(c => !c)
                                    }
                                }}
                            >from library</p>
                            <input type="file" multiple name="upfile" className="btn-hover" accept="image/*" onChange={addImagesHandler} />
                        </div>
                  </Col> :
                    <Row style={{background: "#f3f3f9"  ,  borderRadius: "10px", }} className="my-4 mx-1 py-4 ">

                             <Col md={12} className="parent-div mb-4 mt-1 d-flex flex-lg-row-reverse  " >
                                <Row>
                                    <Col md={6}>
                                        <button type="button" className="btn btn-success px-4 btn-hover btn-upload ">
                                            Upload  </button>
                                        <input type="file" name="upfile" accept="image/*" multiple onChange={addImagesHandler} />
                                    </Col>
                                </Row>
                            </Col>
                         {images.map((img, index) => {
                            return (
                                <ImgModal img={img} index={index} setImages={setImages} />
                            )
                        })}
                    </Row>
                }
            {/* </Row> */}
            <UnitImgModal
                modal={modal}
                toggle={() => setModal(c => !c)}
                id={activeCanvasData ?.constrains?.id} 
                addImageHandler={(uploadedImgs) => {
                    // updatedImages=images.filter(img=>!uploadedImgs.some(item=>item.id===img.id))
                    setImages([...images, ...uploadedImgs])
                    setModal(c => !c)
                }} />
        </>
    )
}

export default FabricCanvas